module.exports = __webpack_public_path__ + "static/3-1d515e584880484abbb6f39000b5193a.jpg";